/*
 * MDB shim for MDBContainer
 * Files currently importing this symbol from "mdbreact":
 * - src/Seating/Accounts/accountDetail.jsx
 * - src/Seating/Faxes/faxes.jsx
 * - src/Seating/Patient/PatientViewComponents/CreateQuoteModalFromTicket.jsx
 * - src/Seating/Patient/deliveryManifest.jsx
 * - src/Seating/Patient/patientInformationView.jsx
 * - src/Seating/Patient/patientOrderView.jsx
 * - src/Seating/Settings/creditCardTypes.jsx
 * - src/Seating/Settings/expenseTypes.jsx
 * - src/Seating/Users/userList.jsx
 */

import MUIContainer from "@mui/material/Container";

export default function MDBContainer({ children, fluid, ...rest }) {
    return (
        <MUIContainer maxWidth={fluid ? false : "lg"} {...rest}>
            {children}
        </MUIContainer>
    );
}
